import { Mail, Phone, Calendar } from "lucide-react";

const STATUS = [
  { v: "new", label: "New" },
  { v: "contacted", label: "Contacted" },
  { v: "completed", label: "Completed" },
];

export default function RequestCard({ r, onStatus }) {
  return (
    <article className="glass rounded-2xl p-6 md:p-8" data-testid={`request-card-${r.id}`}>
      <div className="flex flex-col md:flex-row md:justify-between gap-4">
        <div>
          <h3 className="font-heading text-xl text-gold-soft" data-testid="request-card-name">{r.name}</h3>
          <p className="text-sm text-gold mt-1">{r.service}</p>
          <p className="text-xs text-[#f7f1e1]/50 mt-1">Sent {new Date(r.created_at).toLocaleString()}</p>
        </div>
        <select value={r.status} onChange={(e) => onStatus(r.id, e.target.value)} className="field !w-full md:!w-44 shrink-0 self-start" data-testid={`request-status-select-${r.id}`}>
          {STATUS.map((s) => <option key={s.v} value={s.v}>{s.label}</option>)}
        </select>
      </div>
      <div className="flex flex-wrap gap-x-6 gap-y-2 mt-5 text-sm text-[#f7f1e1]/80">
        <a href={`mailto:${r.email}`} className="inline-flex items-center gap-2 hover:text-gold" data-testid="request-card-email"><Mail size={14} />{r.email}</a>
        {r.phone && <a href={`tel:${r.phone}`} className="inline-flex items-center gap-2 hover:text-gold"><Phone size={14} />{r.phone}</a>}
        {r.preferred_date && <span className="inline-flex items-center gap-2"><Calendar size={14} />{r.preferred_date}</span>}
      </div>
      <p className="mt-5 text-[#f7f1e1]/85 leading-relaxed whitespace-pre-line" data-testid="request-card-message">{r.message}</p>
    </article>
  );
}
